import React  from 'react';
import './App.css';
import './Recent.css';
import RecentMainToolbar from './RecentMainToolbar.js';

import RecentRooms from './RecentRooms.js';
import RecentOccupancy from './RecentOccupancy.js';
import ReportBillListAll from './ReportBillListAll.js';
import RecentBankStatementList from './RecentBankStatementList.js';
import RecentPartnerList from './RecentPartnerList.js';

class RecentMain extends React.Component {

	constructor(props) {

		super(props);
		
		this.state = {
			tab: "rooms",
		};
		
		this.setTab = this.setTab.bind(this);
		this.renderRooms = this.renderRooms.bind(this);
		this.renderOccupancy = this.renderOccupancy.bind(this);
		this.renderAllBills = this.renderAllBills.bind(this);
		this.renderBankStatements = this.renderBankStatements.bind(this);
		this.renderPartners = this.renderPartners.bind(this);
		this.renderTab = this.renderTab.bind(this);
	}

	componentDidMount() {
	}
	
	componentDidUpdate() {
	}

	setTab(tab) {
		this.setState({
			tab: tab,
		});
	}
	
	renderRooms() {
		return (
			<RecentRooms
				calcHelpersObj={this.props.calcHelpersObj}
				baseURLAPI={this.props.baseURLAPI}
				email={this.props.email}
				dashboardAppUserType={this.props.dashboardAppUserType}
				dashboardListJsonObj={this.props.dashboardListJsonObj}
				setTab={this.setTab}
				getLang={this.props.getLang}
				getEURString={this.props.getEURString}
				getDateTimeStringFromUnixTimeSec={this.props.getDateTimeStringFromUnixTimeSec}
				getMonthString={this.props.getMonthString}
				getDayOfWeek={this.props.getDayOfWeek}
				getWeekdayStringShort={this.props.getWeekdayStringShort}
				setSelectedDashboard={this.props.setSelectedDashboard}
			/>
		);
	}

	renderOccupancy() {
		return (
			<RecentOccupancy
				calcHelpersObj={this.props.calcHelpersObj}
				baseURLAPI={this.props.baseURLAPI}
				email={this.props.email}
				dashboardAppUserType={this.props.dashboardAppUserType}
				dashboardListJsonObj={this.props.dashboardListJsonObj}
				seletedYear={this.props.seletedYear}
				setTab={this.setTab}
				getLang={this.props.getLang}
				getEURString={this.props.getEURString}
				getDateTimeStringFromUnixTimeSec={this.props.getDateTimeStringFromUnixTimeSec}
				getMonthString={this.props.getMonthString}
				getDayOfWeek={this.props.getDayOfWeek}
				getWeekdayStringShort={this.props.getWeekdayStringShort}
				setSelectedDashboard={this.props.setSelectedDashboard}
				setSelectedYear={this.props.setSelectedYear}
			/>
		);
	}
	
	renderAllBills() {
		return (
			<ReportBillListAll
				calcHelpersObj={this.props.calcHelpersObj}
				baseURLAPI={this.props.baseURLAPI}
				dashboardAppUserType={this.props.dashboardAppUserType}
				dashboardUserType={this.props.dashboardUserType}
				email={this.props.email}
				fullName={this.props.fullName}
				companyID={this.props.companyID}
				selectedYear={this.props.selectedYear}
				setTab={this.setTab}
				getLang={this.props.getLang}
				getEURString={this.props.getEURString}
				getDateTimeStringFromUnixTimeSec={this.props.getDateTimeStringFromUnixTimeSec}
				getMonthString={this.props.getMonthString}
				getTwoDigits={this.props.getTwoDigits}
				showToast={this.props.showToast}
				setSelectedYear={this.props.setSelectedYear}
			/>
		);
	}
	
	renderBankStatements() {
		return (
			<RecentBankStatementList
				calcHelpersObj={this.props.calcHelpersObj}
				baseURLAPI={this.props.baseURLAPI}
				dashboardAppUserType={this.props.dashboardAppUserType}
				dashboardUserType={this.props.dashboardUserType}
				email={this.props.email}
				fullName={this.props.fullName}
				companyID={this.props.companyID}
				selectedYear={this.props.selectedYear}
				setTab={this.setTab}
				getLang={this.props.getLang}
				getEURString={this.props.getEURString}
				getDateTimeStringFromUnixTimeSec={this.props.getDateTimeStringFromUnixTimeSec}
				getMonthString={this.props.getMonthString}
				getTwoDigits={this.props.getTwoDigits}
				showToast={this.props.showToast}
				setSelectedYear={this.props.setSelectedYear}
			/>
		);
	}
	
	renderPartners() {
		return (
			<RecentPartnerList
				calcHelpersObj={this.props.calcHelpersObj}
				baseURLAPI={this.props.baseURLAPI}
				dashboardAppUserType={this.props.dashboardAppUserType}
				dashboardUserType={this.props.dashboardUserType}
				email={this.props.email}
				fullName={this.props.fullName}
				companyID={this.props.companyID}
				selectedYear={this.props.selectedYear}
				setTab={this.setTab}
				getLang={this.props.getLang}
				getEURString={this.props.getEURString}
				getDateTimeStringFromUnixTimeSec={this.props.getDateTimeStringFromUnixTimeSec}
				getMonthString={this.props.getMonthString}
				getTwoDigits={this.props.getTwoDigits}
				showToast={this.props.showToast}
			/>
		);
	}

	renderTab() {
		
		var tab = this.state.tab;
		
		if (tab === "rooms") {
			return this.renderRooms();
		}

		if (tab === "occupancy") {
			return this.renderOccupancy();
		}
		
		if (tab === "allbills") {
			return this.renderAllBills();
		}
		
		if (tab === "bankstatements") {
			return this.renderBankStatements();
		}
		
		if (tab === "partners") {
			return this.renderPartners();
		}
	}

	render() {

		var dashboardAppUserType = this.props.dashboardAppUserType;
		var dashboardUserType = this.props.dashboardUserType;

		if (dashboardAppUserType === 0) {
			return;
		}

		if (dashboardAppUserType === 1) {
			if (dashboardUserType === 0) {
				return;
			}
		}
		
		return (
			<div className="RecentMainTopContainer">
				<RecentMainToolbar
					dashboardAppUserType={this.props.dashboardAppUserType}
					dashboardUserType={this.props.dashboardUserType}
					email={this.props.email}
					dashboardVariableListJsonObj={this.state.dashboardVariableListJsonObj}
					tab={this.state.tab}
					setTab={this.setTab}
					getLang={this.props.getLang}
				/>
				{this.renderTab()}
			</div>
		);
	}
}

export default RecentMain;

